module.exports = __webpack_public_path__ + "img/collection-engagementRingsLabGrownDiamonds@2x.e54d69e.jpg";